module.exports = __webpack_public_path__ + "static/interactiveContentYes-bc7e3403410f42808706c85eb5c9ab4d.png";